'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStore = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _axios = require('plugins/axios');

var _axios2 = _interopRequireDefault(_axios);

var _api = require('plugins/api');

var _api2 = _interopRequireDefault(_api);

var _systemAide = require('components/system-aide');

var _systemAide2 = _interopRequireDefault(_systemAide);

var _list = require('@/components/list');

var _list2 = _interopRequireDefault(_list);

var _skeletonScreen = require('@/components/skeleton-screen');

var _skeletonScreen2 = _interopRequireDefault(_skeletonScreen);

var _customLayout = require('@/components/custom-layout');

var _customLayout2 = _interopRequireDefault(_customLayout);

var _localforage = require('localforage');

var _localforage2 = _interopRequireDefault(_localforage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {};
(0, _assign2.default)(components, {
  list: _list2.default,
  SkeletonScreen: _skeletonScreen2.default,
  CustomLayout: _customLayout2.default
});
var localStore = exports.localStore = _localforage2.default.createInstance({
  name: 'olympics'
});
exports.default = {
  install: function install(Vue, options) {
    (0, _assign2.default)(Vue.prototype, {
      $ajax: _axios2.default,
      $api: _api2.default,
      $aide: _systemAide2.default
    });
    var hide = Vue.prototype.$Spin.hide;
    Vue.prototype.$setRefs = function (name, key, value) {
      /* eslint-disable no-new */
      if (!name || !key) {
        throw new Error('name and key must be required, error from $setRefs');
      }
      var ref = this.$refs[name];
      if (!ref) {
        console.error(name + ' not found in $refs');
        return this;
      }
      ref.$set(key, value || '');
    };
    Vue.prototype.$methods = function (name, key) {
      /* eslint-disable no-new */
      if (!name || !key) {
        throw new Error('name and key must be required, error from $methods');
      }
      var ref = this.$refs[name];
      if (!ref) {
        console.error(name + ' not found in $methods');
        return this;
      }

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      ref[key] && ref[key].apply(ref, args);
    };
    Vue.prototype.$Spin.hide = function () {
      var ishidden = document.body.style.overflow === 'hidden';
      hide.apply(this, arguments);
      Vue.nextTick(function () {
        ishidden && (document.body.style.overflow = 'initial');
      });
    };
    Vue.prototype.$local = localStore;
    (0, _keys2.default)(components).forEach(function (key) {
      Vue.component(key, components[key]);
    });
  }
};